import { Estado } from './estado';
import { Generico } from './generico';

export class Cidade extends Generico {
  nome: string;
  estado: Estado;
  iss?: number;
  ibgeId?: number;

  constructor(data?) {
    super(data);
    if (data) {
      this.nome = data.nome;
      this.estado = data.estado;
      this.iss = data.iss;
      this.ibgeId = data.ibgeId;
    }
  }
}
